import styled from "styled-components";

import colors from "constants/palette";
import DateTime from "./DateTime";
import HeadertLeft from "./HeadertLeft";

export default function Header(params) {
  return (
    <Container>
      <DateTime />
      <HeadertLeft />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  border-bottom: 1px solid ${colors.gray + "60"};
  height: 120px;
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 0 16px;

  @media (max-width: 720px) {
    height: 142px;
  }
`;
